import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <MantineProvider>
      <ModalsProvider>
          <App />
      </ModalsProvider>
    </MantineProvider>
  </Provider>
);
